export const getLabelText = (label: string, optional?: boolean) =>
  !optional || /optional/i.test(label) ? label : `${label} (optional)`;
